// libraries
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Divider, notification } from 'antd';

// components
import { Spinner } from '../../../shared/spinner';
import { UnionPageHeader } from './union-page-header';
import { UnionPageForm } from './union-page-form';

// services
import * as UnionService from '../../../../services/bb-api/union';

export function UnionPageRoute(): JSX.Element {
	const [union, setUnion] = useState<Record<string, any>>({});
	const [loading, setLoading] = useState<boolean>(true);

	const { id }: Record<string, any> = useParams();
	const history = useHistory();

	useEffect(() => {
		async function getResources() {
			setLoading(true);

			try {
				const union: Record<string, any> = await UnionService.get(id);
				setUnion(union);
			} catch (error) {
				history.replace('/unions');
				const message: string = (error as Error).name;
				const description: string = (error as Error).message;
				notification.error({ message, description });
			}

			setLoading(false);
		}

		getResources();
	}, [history, id]);

	if (loading) {
		return <Spinner text="Getting data..." />;
	}

	return (
		<StyledMain>
			<UnionPageHeader union={union} />
			<Divider />
			<UnionPageForm useUnion={[union, setUnion]} />
		</StyledMain>
	);
}

const StyledMain = styled.main`
	padding: 2em;
	display: flex;
	flex-direction: column;
`;
